import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { aiPackage } from "@/mocks/aiPlanData";

const BRAND = "#FF6B35";

const products = [
  { icon: "🏨", name: aiPackage.hotel.name, spec: "豪华海景大床房 · 4晚", price: aiPackage.hotel.price },
  { icon: "🚗", name: aiPackage.car.model, spec: "7座商务车 · 含司机 · 4天", price: aiPackage.car.price },
  { icon: "🗺️", name: aiPackage.tour.name, spec: aiPackage.tour.summary, price: aiPackage.tour.price },
  { icon: "👩‍✈️", name: `导游 · ${aiPackage.guide.name}`, spec: "普通话/英语 · 3天", price: aiPackage.guide.price },
];

const totalPrice = products.reduce((s, p) => s + p.price, 0);
const depositAmount = Math.round(totalPrice * 0.2);

export default function DepositPaymentPage() {
  const navigate = useNavigate();
  const [method, setMethod] = useState<"wechat" | "alipay">("wechat");
  const [paying, setPaying] = useState(false);
  const [success, setSuccess] = useState(false);

  const payMethods = [
    { key: "wechat" as const, icon: "ri-wechat-pay-line", label: "微信支付", color: "#07C160" },
    { key: "alipay" as const, icon: "ri-alipay-line", label: "支付宝", color: "#1677FF" },
  ];

  const handlePay = () => {
    setPaying(true);
    setTimeout(() => {
      setPaying(false);
      setSuccess(true);
    }, 1800);
  };

  if (success) {
    return (
      <div
        className="min-h-screen flex flex-col items-center justify-center px-6"
        style={{ background: "#F7F7F7", fontFamily: "'SF Pro Text','PingFang SC','Inter',system-ui,sans-serif" }}
      >
        {/* 成功图标 */}
        <div
          className="w-20 h-20 rounded-full flex items-center justify-center mb-6"
          style={{ background: "linear-gradient(135deg, #FF6B35, #FF9A5C)" }}
        >
          <i className="ri-check-line text-white" style={{ fontSize: 40 }} />
        </div>
        <div className="text-xl font-bold text-gray-900 mb-2">订金支付成功！</div>
        <div className="text-sm text-gray-500 text-center mb-2 leading-relaxed">
          已支付订金 <span className="font-bold" style={{ color: BRAND }}>¥{depositAmount.toLocaleString()}</span>
        </div>

        {/* 服务承诺卡片 */}
        <div
          className="w-full rounded-2xl p-5 mb-6"
          style={{ background: "#fff", border: "1.5px solid #FFE4CC" }}
        >
          <div className="flex items-center gap-2 mb-4">
            <div
              className="w-8 h-8 rounded-xl flex items-center justify-center"
              style={{ background: "linear-gradient(135deg,#FF6B35,#FF9A5C)" }}
            >
              <i className="ri-customer-service-2-line text-white" style={{ fontSize: 15 }} />
            </div>
            <div>
              <div className="text-sm font-bold text-gray-900">需求询单已创建</div>
              <div className="text-xs text-gray-400">单号：IQ20250413001</div>
            </div>
          </div>
          <div className="space-y-3">
            {[
              { icon: "ri-user-heart-line", color: "#FF6B35", title: "专属管家匹配中", desc: "工作人员将在2小时内与您联系" },
              { icon: "ri-map-2-line", color: "#2563EB", title: "方案深度定制", desc: "根据您的需求量身打造最优行程" },
              { icon: "ri-secure-payment-line", color: "#059669", title: "尾款支付保障", desc: "确认方案后再支付尾款，放心无忧" },
            ].map((item, i) => (
              <div key={i} className="flex items-start gap-3">
                <div
                  className="w-8 h-8 rounded-xl flex items-center justify-center flex-shrink-0"
                  style={{ background: `${item.color}12` }}
                >
                  <i className={item.icon} style={{ color: item.color, fontSize: 15 }} />
                </div>
                <div>
                  <div className="text-sm font-semibold text-gray-800">{item.title}</div>
                  <div className="text-xs text-gray-400 mt-0.5">{item.desc}</div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="w-full space-y-2.5">
          <button
            onClick={() => navigate("/inquiry-orders")}
            className="w-full py-3.5 rounded-2xl text-sm font-bold text-white cursor-pointer whitespace-nowrap active:scale-[0.98] transition-all"
            style={{ background: `linear-gradient(135deg, ${BRAND}, #FF9A5C)` }}
          >
            查看需求询单
          </button>
          <button
            onClick={() => navigate("/home")}
            className="w-full py-3 rounded-2xl text-sm font-semibold cursor-pointer whitespace-nowrap"
            style={{ background: "#F5F5F5", color: "#6B7280" }}
          >
            返回首页
          </button>
        </div>
      </div>
    );
  }

  return (
    <div
      className="min-h-screen pb-[calc(env(safe-area-inset-bottom,0px)+144px)]"
      style={{ background: "#F7F7F7", fontFamily: "'SF Pro Text','PingFang SC','Inter',system-ui,sans-serif" }}
    >
      {/* Header */}
      <div
        className="relative overflow-hidden"
        style={{ background: "linear-gradient(145deg,#1A1A2E 0%,#16213E 60%,#0F3460 100%)" }}
      >
        <div className="absolute inset-0 pointer-events-none overflow-hidden">
          <div
            className="absolute rounded-full"
            style={{ width: 180, height: 180, top: -40, right: -20, background: "rgba(255,107,53,0.12)", filter: "blur(35px)" }}
          />
        </div>
        <div className="relative px-5 pb-5" style={{ paddingTop: "calc(env(safe-area-inset-top, 0px) + 48px)" }}>
          <div className="flex items-center gap-3 mb-5">
            <button
              onClick={() => navigate(-1)}
              className="w-9 h-9 flex items-center justify-center rounded-full cursor-pointer flex-shrink-0"
              style={{ background: "rgba(255,255,255,0.1)", border: "1px solid rgba(255,255,255,0.15)" }}
            >
              <i className="ri-arrow-left-line" style={{ fontSize: 18, color: "#fff" }} />
            </button>
            <div className="flex-1">
              <div className="text-sm font-bold text-white">支付订金</div>
              <div className="text-xs mt-0.5" style={{ color: "rgba(255,255,255,0.45)" }}>需求询单 · 美伊旅行</div>
            </div>
            <span
              className="text-xs font-semibold px-3 py-1 rounded-full"
              style={{ background: "rgba(255,107,53,0.25)", color: "#FF9A5C", border: "1px solid rgba(255,107,53,0.3)" }}
            >
              AI度假套餐
            </span>
          </div>

          {/* 订金金额展示 */}
          <div
            className="rounded-2xl p-4"
            style={{ background: "rgba(255,255,255,0.07)", border: "1px solid rgba(255,255,255,0.1)" }}
          >
            <div className="text-xs mb-1" style={{ color: "rgba(255,255,255,0.5)" }}>三亚5天4晚度假套餐 · 4人</div>
            <div className="flex items-end justify-between mb-3">
              <div>
                <div className="text-xs mb-0.5" style={{ color: "rgba(255,255,255,0.5)" }}>本次支付订金（20%）</div>
                <div className="text-3xl font-bold" style={{ color: "#FF9A5C" }}>
                  ¥{depositAmount.toLocaleString()}
                </div>
              </div>
              <div className="text-right">
                <div className="text-xs" style={{ color: "rgba(255,255,255,0.35)" }}>套餐总价</div>
                <div className="text-sm font-medium line-through" style={{ color: "rgba(255,255,255,0.3)" }}>
                  ¥{totalPrice.toLocaleString()}
                </div>
              </div>
            </div>
            <div className="h-px mb-3" style={{ background: "rgba(255,255,255,0.08)" }} />
            {/* 尾款说明 */}
            <div className="flex items-start gap-2">
              <i className="ri-information-line flex-shrink-0 mt-0.5" style={{ color: "rgba(255,200,150,0.7)", fontSize: 13 }} />
              <p className="text-xs leading-relaxed" style={{ color: "rgba(255,200,150,0.7)" }}>
                支付成功后，专属管家将在2小时内联系您进行方案确认，尾款 ¥{(totalPrice - depositAmount).toLocaleString()} 将在双方确认后支付
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="px-4 py-4 space-y-3">

        {/* 服务说明 */}
        <div
          className="rounded-2xl p-4"
          style={{ background: "#FFF8F0", border: "1.5px solid #FFE4CC" }}
        >
          <div className="flex items-center gap-2 mb-3">
            <i className="ri-customer-service-2-line" style={{ color: BRAND, fontSize: 16 }} />
            <span className="text-sm font-bold text-gray-900">当前为需求询单</span>
          </div>
          <div className="space-y-2.5">
            {[
              { step: "01", title: "支付20%订金", desc: "确认意向，锁定专属服务资源", color: BRAND },
              { step: "02", title: "专属管家对接", desc: "2小时内分配专属管家，深度沟通需求", color: "#2563EB" },
              { step: "03", title: "方案确认与尾款", desc: "管家制定方案，您确认后支付剩余80%", color: "#7C3AED" },
              { step: "04", title: "正式订单生成", desc: "尾款支付后自动转化为正式旅行订单", color: "#059669" },
            ].map((s) => (
              <div key={s.step} className="flex items-start gap-3">
                <div
                  className="w-6 h-6 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5"
                  style={{ background: `${s.color}18` }}
                >
                  <span className="text-xs font-bold" style={{ color: s.color }}>{s.step}</span>
                </div>
                <div>
                  <div className="text-xs font-semibold text-gray-800">{s.title}</div>
                  <div className="text-xs text-gray-400">{s.desc}</div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* 产品清单 */}
        <div className="rounded-2xl overflow-hidden" style={{ background: "#fff" }}>
          <div className="px-4 pt-3.5 pb-1">
            <span className="text-sm font-bold text-gray-900">套餐包含产品</span>
          </div>
          {products.map((p, idx) => (
            <div
              key={idx}
              className="flex items-center justify-between px-4 py-3"
              style={{ borderTop: idx > 0 ? "1px solid #F5F5F5" : "none" }}
            >
              <div className="flex items-center gap-2.5">
                <span style={{ fontSize: 18 }}>{p.icon}</span>
                <div>
                  <div className="text-xs font-semibold text-gray-800">{p.name}</div>
                  <div className="text-xs text-gray-400">{p.spec}</div>
                </div>
              </div>
              <span className="text-sm font-bold" style={{ color: "#374151" }}>¥{p.price.toLocaleString()}</span>
            </div>
          ))}
          <div
            className="flex items-center justify-between px-4 py-3"
            style={{ borderTop: "1px solid #F0F0F0", background: "#FAFBFC" }}
          >
            <span className="text-xs text-gray-500">套餐总价</span>
            <span className="text-sm font-bold text-gray-700">¥{totalPrice.toLocaleString()}</span>
          </div>
        </div>

        {/* 支付方式 */}
        <div className="rounded-2xl overflow-hidden" style={{ background: "#fff" }}>
          <div className="px-4 pt-3.5 pb-2">
            <span className="text-xs font-bold text-gray-500 uppercase tracking-widest">选择支付方式</span>
          </div>
          {payMethods.map((m, idx) => (
            <button
              key={m.key}
              onClick={() => setMethod(m.key)}
              className="w-full flex items-center gap-3 px-4 py-3.5 cursor-pointer transition-all"
              style={{
                borderTop: idx > 0 ? "1px solid #F5F5F5" : "none",
                background: method === m.key ? "#FFF8F5" : "#fff",
              }}
            >
              <div
                className="w-10 h-10 flex items-center justify-center rounded-xl"
                style={{ background: `${m.color}15` }}
              >
                <i className={m.icon} style={{ color: m.color, fontSize: 22 }} />
              </div>
              <div className="flex-1 text-left">
                <div className="text-sm font-semibold text-gray-800">{m.label}</div>
              </div>
              <div
                className="w-5 h-5 rounded-full flex items-center justify-center flex-shrink-0"
                style={{
                  background: method === m.key ? BRAND : "transparent",
                  border: method === m.key ? "none" : "2px solid #E5E7EB",
                }}
              >
                {method === m.key && <i className="ri-check-line text-white" style={{ fontSize: 12 }} />}
              </div>
            </button>
          ))}
        </div>
      </div>

      {/* 底部支付按钮 */}
      <div
        className="fixed bottom-0 left-0 right-0 bg-white px-4 z-40"
        style={{ borderTop: "1px solid #F5F5F5", paddingTop: "8px", paddingBottom: "calc(8px + env(safe-area-inset-bottom, 0px))" }}
      >
        <div className="flex items-center justify-between mb-3">
          <div>
            <div className="text-xs text-gray-400">本次支付订金</div>
            <div className="text-2xl font-bold" style={{ color: BRAND }}>¥{depositAmount.toLocaleString()}</div>
          </div>
          <div className="text-right">
            <div className="text-xs text-gray-400">套餐总价</div>
            <div className="text-sm font-medium text-gray-400 line-through">¥{totalPrice.toLocaleString()}</div>
          </div>
        </div>
        <button
          onClick={handlePay}
          disabled={paying}
          className="w-full py-4 rounded-2xl text-sm font-bold text-white cursor-pointer whitespace-nowrap active:scale-[0.98] transition-all flex items-center justify-center gap-2"
          style={{ background: `linear-gradient(135deg, ${BRAND}, #FF9A5C)` }}
        >
          {paying ? (
            <>
              <i className="ri-loader-4-line animate-spin" style={{ fontSize: 16 }} />
              支付中...
            </>
          ) : (
            <>
              <i className="ri-secure-payment-line" style={{ fontSize: 16 }} />
              立即支付订金 ¥{depositAmount.toLocaleString()}
            </>
          )}
        </button>
        <div className="text-center text-xs text-gray-400 mt-2">
          支付即表示同意《需求询单服务协议》
        </div>
      </div>
    </div>
  );
}
